<script lang="ts">
      import { getLocaleContext } from '$lib/components/locale/ts/Locale.svelte'
      import type { EditorNode, Transformer, TransformerFunction } from '$lib/lexical/parser/index.ts'
      import { urlFromRelation } from '$lib/utils/payload/relations'


      let { node, children = undefined } = $props()

      const locale = getLocaleContext()

      type LinkNode = {
            fields: {
                  url: string
                  newTab?: boolean
                  linkType: 'custom'
            }
      } & EditorNode

      type InternalLinkNode = {
            fields: {
                  doc: {
                        relationTo: string
                        value: number|any
                  },
                  newTab?: boolean
                  linkType: 'internal'
            }
      } & EditorNode

      const {
            format,
            fields,
      }: InternalLinkNode|LinkNode = $state(node)

      let url = $derived.by( () => {
        if( node.fields.linkType == "custom") return locale.getLocaleLink(node.fields.url)
        else if( node.fields.doc ) return locale.getLocaleLink(urlFromRelation(node.fields.doc))
        return "#"
      })

      const newTab = $derived(fields.newTab == true ? "'_blank'" : "_self")
</script>

<a class="lexical-link {format}" href={url} target="{newTab}">
      <!--{text == "" ? url : text}-->
      {#if node.children?.length == 0}
            {url}
      {/if}
      {@render children?.()}
</a>
